import React from 'react';

import * as Styled from './guide-card.styled';

type OwnProps = {
	img: string;
	title: string;
	description: string;
};

const GuideCard: React.FC<OwnProps> = ({ img, title, description }) => {
	return (
		<Styled.Wrapper>
			<Styled.TitleRow>
				<Styled.ImageWrapper>
					<img src={img} alt='img' />
				</Styled.ImageWrapper>
				<Styled.Title>{title}</Styled.Title>
			</Styled.TitleRow>
			<Styled.Description>{description}</Styled.Description>
		</Styled.Wrapper>
	);
};

export default GuideCard;
